import template from './settings.html';
import controller from './settings.controller';

const messageOutboundSettingsComponent = {
  restrict: 'E',
  controller,
  template
};

export default messageOutboundSettingsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/settings/settings.component.js
 **/